import React from 'react'

function Servicess() {
  return (
    <div className="servicess">
        <div className="container-fluid p-5 ">
            <div className="content ">
                <h1 className="services-title">Our Services</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.<br></br>
                     Vero ea debitis fuga aliquid eaque magni itaque incidunt voluptate,<br></br>
                      a asperiores ducimus excepturi hic necessitatibus<br></br>
                       fugiat quisquam deserunt quas harum eos voluptates.<br></br>
                     Aliquid voluptatibus sed veritatis quae alias, dicta deleniti quod?</p>
            </div>
        </div>

        
    </div>
  )
}

export default Servicess;